import Icon from "../Icon";
import { RangeInput } from "../inputs/Range";
import { SliderButton } from "./SliderButton";
import "../../styles/buttons/OcrConfidenceThresholdSliderButton.css";

export { OcrConfidenceThresholdSliderButton };

type OcrConfidenceThresholdProps = {
  threshold: number;
  default: number;
  update: (value: number) => void;
};
function OcrConfidenceThresholdSliderButton(
  props: OcrConfidenceThresholdProps,
) {
  return (
    <SliderButton
      label={"Change OCR confidence threshold"}
      buttonChildrenFn={(value) => (
        <>
          {value === -1 && "Default: " + props.default + "%"}
          {value > -1 && value + "%"}
          <Icon altText={"Change OCR confidence threshold"} icon={"cog"} />
        </>
      )}
      buttonClassName={"white fuzzyThreshold ocrConfidenceThreshold"}
      rangeInputChildren={(value, onMove, onChange) => (
        <RangeInput
          label={"OCR Confidence Threshold"}
          className={"fuzzyRange"}
          value={value}
          inputLabel
          min={-1}
          max={100}
          onChange={onChange}
          onMove={onMove}
        />
      )}
      threshold={props.threshold}
      update={props.update}
    />
  );
}
